import { render } from "./Navigation.vue?vue&type=template&id=508cf337&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=508cf337&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-508cf337"

export default script